import React, { useEffect } from "react";
import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import { heliosAdminActions } from "../../reducers/heliosAdmin";
import { ContainerBg } from "../../useGeneralStyles";
import { APIAccounts } from "../../api";

import * as Component from "./components";

const HeliosAdmin = (): React.ReactElement => {
  const dispatch = useDispatch();

  const {
    data: { liveSimCount, liveCount },
  } = useSelector((state) => state.heliosAdmin.simAndLiveSimAccounts);

  useEffect(() => {
    (async () => {
      try {
        dispatch(heliosAdminActions.fetchSimAndLiveSimAccountsRequest());
        const response = await APIAccounts.getLiveAndLiveSimAccountsCountRequest();
        dispatch(heliosAdminActions.fetchSimAndLiveSimAccountsSuccess(response));
      } catch (error) {
        console.error("Error handle get getLiveAndLiveSimAccountsCountRequest", error);
        dispatch(heliosAdminActions.fetchSimAndLiveSimAccountsFailed());
      }
    })();
  }, []);

  return (
    <ContainerBg>
      <Grid container spacing={3}>
        <Grid item xs={3}>
          <Component.AccountsCounter title="Live accounts" count={liveCount} />
        </Grid>
        <Grid item xs={3}>
          <Component.AccountsCounter title="LiveSims accounts" count={liveSimCount} />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Component.AccountsOver8KWithdrawals />
        </Grid>
      </Grid>
    </ContainerBg>
  );
};

export default HeliosAdmin;
